<template>
    <v-dialog v-model="shows" width="560">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card>
            <v-card-title class="justify-center"> 교육서비스 안내 </v-card-title>
            <v-card-text class="text-center">
                교육서비스는 YOUTUBE, VIMEO 영상 플랫폼과 연계하여 <br />
                회원들의 교육 영상 시청 및 시청 여부 확인을 위한 기능입니다. <br />
                <br />
                YOUTUBE, VIMEO의 별도 회원 가입 후 영상 등록 및 영상 스트리밍 기능 이용시 <br />
                해당 사이트의 사용하는 영상의 링크를 입력하여 이용이 가능합니다. <br />
                <br />
                영상을 시청중인 회원과 채팅 서비스가 제공되며 <br />
                영상을 시청한 회원의 시청 시간이 문서로 제공됩니다. <br />
            </v-card-text>
            <v-btn absolute text icon top right class="mt-n8 mr-n4" @click="shows = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    data: () => ({
        shows: false,
    }),
};
</script>

<style></style>
